import React from "react";
import styled, { css, keyframes } from "styled-components";
import MySwiper from "./MySwiper";

import useSound from "use-sound";

// import lose from "../../../audio/lose.mp3";
// import win from "../../../audio/win.mp3";
import goForward from "../../../audio/goForward.mp3";
const SwiperHitsDiv = styled.div`
  position: relative;
  overflow: hidden;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  width: 103%;
  max-width: 320px;
  margin: auto;
  -webkit-font-smoothing: subpixel-antialiased;
  -webkit-transform: translateZ(0) scale(1, 1);

  /* margin-bottom: 00px; */
  span {
    color: #ffb100;
  }
  h1 {
    font-size: 12px;
    color: #ffb100;
    font-weight: bold;
  }
  p {
    font-size: 12px;
    color: #32075b;
  }

  &::before {
    content: "";
    position: absolute;
    right: 0;
    height: 130%;
    background: rgb(127, 61, 165);
    background: -moz-linear-gradient(
      90deg,
      rgba(127, 61, 165, 1) 0%,
      rgba(127, 61, 165, 0) 23%,
      rgba(127, 61, 165, 0) 77%,
      rgba(127, 61, 165, 1) 100%
    );
    background: -webkit-linear-gradient(
      90deg,
      rgba(127, 61, 165, 1) 0%,
      rgba(127, 61, 165, 0) 23%,
      rgba(127, 61, 165, 0) 77%,
      rgba(127, 61, 165, 1) 100%
    );
    background: linear-gradient(
      90deg,
      rgba(127, 61, 165, 1) 0%,
      rgba(127, 61, 165, 0) 23%,
      rgba(127, 61, 165, 0) 77%,
      rgba(127, 61, 165, 1) 100%
    );
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#7f3da5",endColorstr="#7f3da5",GradientType=1);
    width: 104%;
    z-index: 2;
    pointer-events: none;
  }
`;
const fadeInAnim = keyframes`
  0%{
    animation-timing-function: cubic-bezier(0.17, 0.12, 0, 1);
    transform: scale(0);
    opacity: 0;
    }
    33%{
    animation-timing-function: cubic-bezier(0.17, 0.12, 0, 1);
    opacity: 1;
  }
  100%{
    transform: scale(1);
    opacity: 1;
  }
`;
const fadeIn = css`
  ${fadeInAnim} 1s forwards
`;
const Win = styled.span`
  margin: auto;
  transform: scale(0);
  color: #ffb100;
  opacity: 0;
  animation: ${fadeIn};
`;
export function SwiperHits(props) {
  const { sound, volume } = props;
  const [goForwardSfx] = useSound(goForward, { volume });
  return (
    <SwiperHitsDiv
      className="SwiperHitsDiv"
      mode80={props.mode80}
      modeSonic={props.modeSonic}
      coeficients={props.coeficients}
      onClick={() => {
        if (sound && props.n > 0) goForwardSfx();
        props.n && props.handleAbove("Hits" + (props.n - 1));
      }}
    >
      {props.showWin && props.win > 0 ? (
        <Win className="Win">
          Win {props.win && (+props.win).toFixed(props.toFix)}
        </Win>
      ) : props.won === 0 ? (
        props.n ? (
          <MySwiper p={props} />
        ) : (
          <p>
            select <span> 1 - 10 </span> numbers
          </p>
        )
      ) : (
        <p style={{ textTransform: "none", color: "#ffb100" }}>{`${props.won && props.won
          } ${props.won && props.won === "1" ? "HIT" : "HITS"} | ${props.coeficients.coefs[props.n - 1] &&
          props.coeficients.coefs[props.n - 1][props.won]
          }x`}</p>
      )}
    </SwiperHitsDiv>
  );
}
